import { Routes, Route } from "react-router-dom";

import Home from "../pages/HomePage";
import Formation from "../pages/FormationPage";
import Mentions from "../pages/MentionsPage";
import Charte from "../pages/ChartePage";

const AppNavigator = () => {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
      <Route path="formation/:id" element={<Formation />} />
      <Route path="bilan/:id" element={<Formation />} />
      <Route path="mentions-legales" element={<Mentions />} />
      <Route path="charte-handi" element={<Charte />} />
    </Routes>
  );
};

export default AppNavigator;
